module.exports = "//public.getcloudapp.com/packs/media/images/icons-toggle-close-10226ce425a7c1496d5564246bd8a019.svg";